import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';


import { ADD_HACKATHON_URL } from 'src/constants/configuration';
import App from '../components/App';
import Hackathons from '../components/Hackathons';
import Account from '../components/Account';
import Event from '../components/Event';
import About from '../components/About/About';
import AddProject from 'src/components/AddProject';
import ResetPassword from 'src/components/Authorization/ResetPassword';

function getAddHackBackgroundComponent(prop) {
  const stateParam = prop.location.state;
  if (stateParam && stateParam.from === 'account') {
    return (<Account {...prop} />)
  }
  return <Hackathons {...prop} />;
}

function authViaToken(prop) {
  const regKey = prop.match.params.token;
  return <Redirect to={{ pathname: "/account", state: { regKey } }} />
}

function resetPassword(prop) {
  const resetToken = prop.match.params.token;
  return <Redirect to={{ pathname: "/reset_password", state: { resetToken } }} />
}

const Root = ({ store }) => (
  <Provider store={store}>
    <App>
      <Switch>
        <Route exact path='/' component={Hackathons} />
        <Route exact path='/hackathons' component={Hackathons} />
        <Route exact path='/api/user/password_reset/:token' render={props => resetPassword(props)} />
        <Route exact path='/reset_password' component={ResetPassword} />
        <Route exact path={ADD_HACKATHON_URL} render={props => getAddHackBackgroundComponent(props)} />
        <Route exact path='/api/user/register/:token' render={props => authViaToken(props)} />
        <Route path='/account/:tabName?' component={Account} />
        <Route exact path='/add_project' component={AddProject} />
        <Route exact path='/edit_project/:projectId' component={AddProject} />
        <Route path='/event/:id' component={Event} />
        <Route exact path='/about' component={About} />
      </Switch>
    </App>
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object.isRequired,
}

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.prod.js